// src/components/Writing/WritingInput.tsx
/* eslint-disable max-len */
import React, { FC } from 'react';
import { Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { ReactComponent as ThumbUp } from '../../assets/icons/games/writing/thumbs-up.svg';
import { isAnswerCorrect } from '../../utils/writingAnswer';
import { recordAnswer } from '../../services/activity';
import './WritingInput.less';

type InputProps = {
  content: string,
  // Hasło dosłownie, z nawiasami — do sprawdzania odpowiedzi; content to podpowiedź (hasło bez nawiasów)
  term: string,
  setFeedbackInfo: any,
  setInputContent: any;
  inputContent: any;
  tryAgainButton: boolean,
  tryAgain: any,
  setNextWordButton: (varName: boolean) => void,
  setTryAgainButton: (varName: boolean) => void,
  // Dobra odpowiedź przyjęta — wpisane słowo stoi w polu bez zmian, aż widok przejdzie do następnego
  answeredCorrectly: boolean,
};

export const WritingInput: FC<InputProps> = ({
  content, term, setNextWordButton, setTryAgainButton, setFeedbackInfo, tryAgainButton, inputContent, tryAgain, setInputContent, answeredCorrectly,
}) => {
  const { t } = useTranslation();
  const showNextWordButton = () => {
    setNextWordButton(true);
  };

  // const checkTranslation = (event: { key: string }) => {
  //   if (inputContent !== '' && event.key === 'Enter') {
  //     if (inputContent.toLowerCase().replace(/[<>|:;'"`=?,.\\/]+/g, '') === content.toLowerCase()) {
  //       showNextWordButton();
  //       setTryAgainButton(false);
  //       setInputContent('');
  //       setFeedbackInfo(<ThumbUp />);
  //     } else {
  //       // addWordToRepeat();
  //       setTryAgainButton(true);
  //       setFeedbackInfo(content);
  //     }
  //   }
  // };
  const checkTranslation = (event: { key: string }) => {
    if (!answeredCorrectly && inputContent !== '' && event.key === 'Enter') {
      // Reguły porównania: src/utils/writingAnswer.ts (wspólne z Napisz Easy)
      const isCorrect = isAnswerCorrect(inputContent, term);

      // Monitoring aktywności — działa, gdy gra Napisz ucznia go włączyła (useActivityTracking w WritingView)
      recordAnswer(isCorrect, term);

      if (isCorrect) {
        // Słowo zostaje w polu razem z kciukiem; czyści je widok przy przejściu do następnego
        showNextWordButton();
        setTryAgainButton(false);
        setFeedbackInfo(<ThumbUp />);
      } else {
        // addWordToRepeat();
        setTryAgainButton(true);
        // Uwaga: Jeśli 'content' jest teraz oczyszczony, a chcesz pokazać oryginalny termin,
        // musisz przekazać oryginalny termin jako dodatkowy prop z WritingView.
        setFeedbackInfo(content);
      }
    }
  };

  const handleKeyUp = (event: { key: string; }) => {
    if (tryAgainButton && event.key === 'Enter' && inputContent === '') {
      setInputContent('');
    } else if (tryAgainButton && event.key === 'Enter') {
      tryAgain();
    }
  };

  return (
    <>
      <div className="inputContainer">

        <Input
          ref={(input) => { if (input != null) { input.focus(); } }}
          size="large"
          type="search"
          value={inputContent}
          readOnly={answeredCorrectly}
          placeholder={t('games:writingPlaceholder')}
          onChange={(event) => setInputContent(event.target.value)}
          onKeyPress={checkTranslation}
          className="input"
          onKeyDown={handleKeyUp}
        />

      </div>
    </>
  );
};

export default WritingInput;
